<template>
  <Button type="primary" @click="sendVerificationCode" :disabled="send" size="large">{{label}}</Button>
</template>

<script>
export default {
  props: {
    phoneNum: {
      type: String,
      required: true
    },
    deviceID: {
      type: String,
      required: true
    },
    businessType: {
      type: String,
      required: true
    },
    verification: {
      type: Function,
      default: function() {
        return true;
      }
    }
  },
  data() {
    return {
      codeShow: true, //验证码状态
      num: 59,
      send: false,
      timer: null
    };
  },

  computed: {
    label() {
      if (!this.send) {
        return "获取验证码";
      }
      return `${this.num} 秒`;
    }
  },
  watch: {
    send(val) {
      if (!val) {
        return;
      }
      this.timer = null;
      this.num = 59;
      this.sport();
    }
  },
  methods: {
    sport() {
      this.timer = setInterval(() => {
        this.num--;
        if (this.num > 0) {
          return;
        }
        clearInterval(this.timer);
        this.send = !this.send;
        this.num = 59;
      }, 1000);
    },

    getRequestData() {
      return {
        deviceID: this.deviceID,
        phoneNum: this.phoneNum,
        type: "mobile",
        businessType: this.businessType
      };
    },

    async sendVerificationCode() {
      let status = await this.verification();
      if (!status) {
        return;
      }
      let requsetData = this.getRequestData();
      this.$api.sendVerificationCode(requsetData).then(() => {
        this.$Message.success("验证码发送成功,请注意查收");
        this.send = true;
      });
    }
  }
};
</script>
